<template>
    <div :class="['basic-drawer', { hidden: hidden }]" :style="{ '--duration': `${duration}s` }">
        <div class="drawer-box">
            <div class="drawer-box_header">
                <slot name="header"></slot>
            </div>

            <div class="drawer-box_content">
                <slot></slot>
            </div>

            <div class="drawer-box_footer">
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "BasicDrawer",
    props: {
        duration: {
            type: Number,
            default: 0.22,
        },
    },
    data() {
        return {
            hidden: false,
        };
    },
    methods: {
        hiddenDrawer() {
            this.hidden = true;
        },
    },
};
</script>

<style scoped lang="scss">
.basic-drawer {
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.6);
    overflow: hidden;
    animation: bg var(--duration) linear;

    &.hidden {
        background: rgba(0, 0, 0, 0);
        transition: background var(--duration) linear;

        .drawer-box {
            transform: translateY(100%);
            transition: transform var(--duration) linear;
        }
    }

    .drawer-box {
        // min-height: 300px;
        background-color: #ffffff;
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;

        animation: show var(--duration) linear;

        &_header {
            border-bottom: 1px solid #f1f1f1;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 12px 16px;
        }

        &_content {
            padding: 12px;
        }
    }

    @keyframes bg {
        from {
            background-color: rgba(0, 0, 0, 0);
        }

        to {
            background-color: rgba(0, 0, 0, 0.6);
        }
    }

    @keyframes show {
        from {
            transform: translateY(100%);
        }

        to {
            transform: translateY(0%);
        }
    }
}
</style>
